module.exports = __webpack_public_path__ + "media/images/mobile/Group 555-e8e2dc62a14d5edc07d5ef06e03be6c7.png";